import React from "react";
import { Card } from "react-bootstrap";
import "./BookingItem.css";
import "../../pages/Users/UsersList.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faTrash } from "@fortawesome/free-solid-svg-icons";
import { Tooltip } from "antd";
import { StructureCoach } from "../../types/Structure";

type Props = {
  coach: StructureCoach;
  onDelete?: React.MouseEventHandler<HTMLButtonElement>;
};

function CoachItem({ coach, onDelete }: Props) {
  const initials = `${coach.user.name?.[0] ?? ""}${coach.user.familyName?.[0] ?? ""}`.toUpperCase();

  return (
    <Card className="user-card">
      <Card.Body className="p-3">

        {/* Avatar + nome */}
        <div className="user-card-header">
          <div className="user-avatar">{initials || "?"}</div>
          <div className="user-card-name">
            <span className="user-name">
              {coach.user.name} {coach.user.familyName}
            </span>
          </div>
        </div>

        {/* Info */}
        <div className="user-card-info">
          <div className="user-info-row">
            <FontAwesomeIcon icon={faEnvelope} className="user-info-icon" />
            <span className="user-info-text">{coach.user.email}</span>
          </div>
        </div>

        {/* Azioni */}
        <div className="user-card-footer d-flex justify-content-end">
          <Tooltip title="Dissocia Maestro" mouseEnterDelay={0.3}>
            <button className="circle-button" onClick={onDelete}>
              <FontAwesomeIcon size="sm" icon={faTrash} />
            </button>
          </Tooltip>
        </div>

      </Card.Body>
    </Card>
  );
}

export default CoachItem;
